import React, { useState } from "react";
import "./style.scss";

export interface RadioOption {
  id: number;
  label: string;
  icon: React.ReactNode;
}

interface RadioButtonGroupProps {
  options?: RadioOption[];
  onChange?: (value: number) => void;
  name?: string;
  value: number;
}

const defaultOptions: RadioOption[] = [];

const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
  options = defaultOptions,
  onChange,
  name = "radio-group",
  value
}) => {
  const [selectedValue, setSelectedValue] = useState<number>(value);

  const handleChange = (value: number) => {
    setSelectedValue(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className="radio-button-group">
      {options.map((option) => (
        <label
          key={option.id}
          className={`radio-button ${selectedValue === option.id ? "selected" : ""}`}
        >
          <input
            type="radio"
            name={name}
            value={value}
            checked={selectedValue === option.id}
            onChange={() => handleChange(option.id)}
            className="radio-input"
          />
          <span className="radio-content">
            <span className="radio-icon">{option.icon}</span>
            <span className="radio-label">{option.label}</span>
          </span>
        </label>
      ))}
    </div>
  );
};

export default RadioButtonGroup;
